import {
	SHOW_LOADING,
	BOT_LIST_SUCCESS,
	BOT_FAIL,
	CREATE_NEW_BOT,
	SET_BOT,
	ENTITY_LIST,
	CREATE_NEW_ENTITY,
	INTENT_LIST,
	SET_AGENT_ID,
	DOMAIN_LIST,
	GET_SURVEY,
	SAVE_SURVEY,
	UPDATE_SURVEY,
	POST_SURVEY,
	SET_DRAGGABLE,
	GET_SYSTEM_VARS,
	SAVE_SYSTEM_VARS,
	DELETE_SURVEY,
	RESET_BOT,
	GET_FAQS,
	SAVE_FAQS,
	GET_SMALL_TALKS,
	SAVE_SMALL_TALKS,
	GET_BOT_SETTINGS,
	SAVE_BOT_SETTINGS,
	UPDATE_BOT_SETTINGS,
	SET_BOT_SETTINGS_LOADING,
	SET_BOT_SETTINGS_UPDATING
} from '../constants/Bot';

export const botList = (bots) => {
	return {
		type: BOT_LIST_SUCCESS,
		payload: bots
	}
};

export const setBot = (info) => {
	return {
		type: SET_BOT,
		payload: info
	}
};
export const getEntities = (entities) => {
	return {
		type: ENTITY_LIST,
		payload: entities
	}
};
export const getDomains = (domains) => {
	return {
		type: DOMAIN_LIST,
		payload: domains
	}
};
export const createNewEntity = (entity) => {
	return {
		type: CREATE_NEW_ENTITY,
		payload: entity
	}
};
export const getIntents = (intents) => {
	return {
		type: INTENT_LIST,
		payload: intents
	}
};
export const getFaqs=(faqDomainId)=>{
	return {
		type: GET_FAQS,
		payload: faqDomainId
	}
}
export const saveFaqs=(faqs)=>{
	return {
		type: SAVE_FAQS,
		payload: faqs
	}
}
export const getSmallTalks=(smallTalkDomainId)=>{
	return {
		type: GET_SMALL_TALKS,
		payload: smallTalkDomainId
	}
}
export const saveSmallTalks=(smallTalks)=>{
	return {
		type: SAVE_SMALL_TALKS,
		payload: smallTalks
	}
}

export const showBotMessage = (message) => {
	return {
		type: BOT_FAIL,
		message
	}
};

export const showLoading = () => {
	return {
		type: SHOW_LOADING,
	};
};

export const setDraggable = (draggable) => {
	return {
		type: SET_DRAGGABLE,
		payload: draggable
	};
};

export const setAgentId = (agentId) => {
	return {
		type: SET_AGENT_ID,
		payload: agentId
	};
};

export const getSurvey = () => {
	return {
		type: GET_SURVEY
	}
}

export const postSurvey = (data) => {
	return {
		type: POST_SURVEY,
		payload: data
	}
}

export const updateSurvey = (id, data) => {
	return {
		type: UPDATE_SURVEY,
		payload: {id, data}
	}
}
export const deleteSurvey = (id) => {
	return {
		type: DELETE_SURVEY,
		payload:id
	}
}

export const saveSurvey = (data) => {
	return {
		type: SAVE_SURVEY,
		payload: data
	}
}

export const getSystemVars=()=>{
	return{
		type:GET_SYSTEM_VARS
	}
}
export const saveSystemVars=(sysVars)=>{
	return{
		type:SAVE_SYSTEM_VARS,
		payload:sysVars
	}
}
export const resetBotState=()=>{
    return{
        type : RESET_BOT,

    }
}
export const getBotSettings=()=>{
    return{
        type : GET_BOT_SETTINGS,

    }
}

export const saveBotSettings=(settings)=>{
	return{
        type : SAVE_BOT_SETTINGS,
		payload:settings
    }
}
export const updateBotSettings=({settings,id})=>{
	return{
        type : UPDATE_BOT_SETTINGS,
		payload:{settings,id}
    }
}
export const setBotSettingsLoading=(loading)=>{
	return{
        type : SET_BOT_SETTINGS_LOADING,
		payload:loading
    }
}
export const setBotSettingsUpdating=(updating)=>{
	return{
        type : SET_BOT_SETTINGS_UPDATING,
		payload:updating
    }
}